import React, { ReactNode } from "react";
import { Outlet } from "react-router-dom";

interface ThePaperBrokerLayoutProps {
  children?: ReactNode;
}

const ThePaperBrokerLayout = ({ children }: ThePaperBrokerLayoutProps) => {
  return (
    <>
      <div className="bg-white mx-auto md:px-8 min-h-screen">
        {children || <Outlet />}
      </div>
    </>
  );
};

export default ThePaperBrokerLayout;
